var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLinkedIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin-square",
    width: 28.642,
    height: 28.642,
    viewBox: "0 0 28.642 28.642",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5222",
    "data-name": "Group 5222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M70.321,66.559v5.294H67.252V66.912c0-1.24-.444-2.087-1.555-2.087a1.679,1.679,0,0,0-1.575,1.123,2.119,2.119,0,0,0-.1.748v5.157h-3.07s.042-8.366,0-9.233h3.07v1.308l-.02.03h.02v-.029A3.045,3.045,0,0,1,66.787,62.4C68.806,62.4,70.321,63.723,70.321,66.559ZM57.737,58.168a1.6,1.6,0,1,0-.04,3.192h.02a1.6,1.6,0,1,0,.02-3.192ZM56.182,71.853h3.07V62.62h-3.07Z",
    transform: "translate(-48.84 -50.619)",
    fill: "#737bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M21.728,18.864a2.864,2.864,0,0,0-2.864,2.864V38.914a2.864,2.864,0,0,0,2.864,2.864H38.914a2.864,2.864,0,0,0,2.864-2.864V21.728a2.864,2.864,0,0,0-2.864-2.864Zm0-2.864H38.914a5.728,5.728,0,0,1,5.728,5.728V38.914a5.728,5.728,0,0,1-5.728,5.728H21.728A5.728,5.728,0,0,1,16,38.914V21.728A5.728,5.728,0,0,1,21.728,16Z",
    transform: "translate(-16 -16)",
    fill: "#737bbb"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-linked-in.50034f11.svg";
export { ForwardRef as ReactComponent };